import React, { useState } from 'react';
import t from 'utils/translate';
import SelectInput from 'modules/shared/components/select-input';
import { MenuItem } from '@mui/material';
import { GLOBAL_ACTIVE_INACTIVE } from 'constants/user-settings';

function ActiveInactiveSelector({ initialValue, onChange, ...props }) {
    const [selectedValue, setSelectedValue] = useState(initialValue);

    const handleChange = (e) => {
        setSelectedValue(e.target.value);
        onChange(e.target.value);
    };

    return (
        <SelectInput value={selectedValue} onChange={handleChange} className="info-field-dropdown" {...props}>
            <MenuItem value={GLOBAL_ACTIVE_INACTIVE.INACTIVE}>{t('global_inactive')}</MenuItem>
            <MenuItem value={GLOBAL_ACTIVE_INACTIVE.ACTIVE}>{t('global_active')}</MenuItem>
        </SelectInput>
    );
}
export default ActiveInactiveSelector;
